import React from 'react'
import { observer } from 'mobx-react'
import useSettingsManager from '../hooks/use-settings-manager'

function Help (props) {

  const settings_manager = useSettingsManager()
  const label = settings_manager.getOtherSettings('help', 'Hjælp')
  const href = settings_manager.getOtherSettings('help_href', 'https://nassau.dk')

  return (
    <a href={href} className="help" target={'_blank'}>{label}</a>
  )
}

export default observer(Help)